import React from "react";
import { Link } from "react-router-dom";
import { nextLevels } from "./levels";

/**
 * Два баннера в верху главной — ближайшие шаги человека.
 *
 * Максим 24.08.2026: баннеры должны показывать первые два незакрытых уровня
 * дорожной карты и меняться по мере прохождения. Поэтому содержимое больше не
 * зашито в код — оно берётся из того же списка уровней, что и лента ниже.
 * Пройден уровень — баннер сам показывает следующий.
 *
 * ОГОВОРКА: прогресс платформа пока не отдаёт, состояния уровней в списке
 * образцовые. Значит сменяться баннеры начнут не раньше, чем появится ручка
 * с прогрессом; до тех пор они стоят на первых двух уровнях. Механика при
 * этом готова — менять придётся только источник списка.
 *
 * Второй баннер намеренно выделен золотом: два одинаково ярких блока рядом
 * соревнуются за внимание, и человек не понимает, куда смотреть. Первый шаг
 * спокойный, второй — заметный.
 */


/* Баннеры собираются из уровней: заголовок, к чему уровень ведёт, и кнопка,
   которая раскрывает его задания ниже на странице. Тексты не дублируем —
   иначе название уровня в баннере и в ленте однажды разойдутся. */
export const bannersFromLevels = () =>
  nextLevels(2).map((level, i) => ({
    key: level.key,
    /* Золотом — только второй: см. оговорку в шапке файла. */
    kind: i === 0 ? "calm" : "gold",
    kicker: i === 0 ? "Ваш следующий шаг" : "Дальше по карте",
    title: level.title,
    text: level.banner || level.lead,
    action: {
      label: i === 0 ? "С чего начать →" : "Посмотреть задания →",
      scrollTo: level.key,
    },
  }));

/* Прокрутка к уровню и его раскрытие. Событие, а не общий стейт: баннеры
   и лента уровней — соседи, а не родственники, и связывать их через
   родителя значило бы тащить состояние через всю страницу. */
const goToLevel = (key) => {
  const el = document.getElementById("fw-levels");
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
  window.dispatchEvent(new CustomEvent("fw:open-level", { detail: { key } }));
};

const Banners = () => (
  <div className="fw-banners">
    {bannersFromLevels().map((b) => (
      <section className={`fw-banner fw-banner--${b.kind}`} key={b.key}>
        <span className="fw-banner-kicker">{b.kicker}</span>
        <h2>{b.title}</h2>
        <p>{b.text}</p>

        {b.action &&
          (b.action.href ? (
            <a className="fw-btn" href={b.action.href}>
              {b.action.label}
            </a>
          ) : b.action.scrollTo ? (
            <button
              type="button"
              className="fw-btn ghost"
              onClick={() => goToLevel(b.action.scrollTo)}
            >
              {b.action.label}
            </button>
          ) : (
            <Link className="fw-btn ghost" to={b.action.to}>
              {b.action.label}
            </Link>
          ))}
      </section>
    ))}
  </div>
);

export default Banners;
